import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--up",
  "use": "icon-arrow--up-usage",
  "viewBox": "0 0 8 4",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 4\" id=\"icon-arrow--up\"><path d=\"M6.943 3.447A.182.182 0 0 0 7 3.318a.172.172 0 0 0-.057-.129L4.137.553A.195.195 0 0 0 4 .5a.204.204 0 0 0-.137.053L1.057 3.19A.182.182 0 0 0 1 3.32a.172.172 0 0 0 .057.128.195.195 0 0 0 .137.053.205.205 0 0 0 .137-.053L4 .94l2.67 2.507a.2.2 0 0 0 .136.053.2.2 0 0 0 .136-.053Z\" fill=\"currentColor\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol